export default __webpack_public_path__ + "static/media/two.e62f514f.png";